import { FormattedMessage } from 'react-intl'

import Box from 'app/components/base/Box'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

const ImportDutiesHint = () => {
  return (
    <Box
      sx={{
        width: '100%',
        borderRadius: IS_NATIVE_APP ? 8 : 1,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'stroke.main',
        backgroundColor: 'background.disabled',
        px: 2,
        py: 1.5
      }}
    >
      <Stack spacing={0.5}>
        <Text variant="body2" sx={{ fontWeight: 500, color: 'text.primary' }}>
          <FormattedMessage defaultMessage="Import Duties & Taxes" />
        </Text>

        <Text variant="body2" color="text.third">
          <FormattedMessage defaultMessage="International orders may be subject to import duties, taxes and customs charges." />
        </Text>
      </Stack>
    </Box>
  )
}

export default ImportDutiesHint
